import Vue from 'vue';
import Vuex from 'vuex';
import vuetify from '@/plugins/vuetify';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    preferencesDrawer: false,
    preferences: {
      contrast: 'light',
      theme: 'blue',
    },
  },
  mutations: {
    // Same theme is used in a light and dark variant, e.g. light green and dark green
    setTheme(state, theme) {
      Vue.set(state.preferences, 'theme', theme);
      vuetify.framework.theme.themes.dark = vuetify.userPreset.theme.themes[theme];
      vuetify.framework.theme.themes.light = vuetify.userPreset.theme.themes[theme];
    },
    // Now you can switch between the light and dark version of the green theme
    setContrast(state, contrast) {
      Vue.set(state.preferences, 'contrast', contrast);
      vuetify.framework.theme.dark = contrast === 'dark';
    },
  },
});
